import { render, staticRenderFns } from "./SaleOfProducts.vue?vue&type=template&id=454983bd&scoped=true"
import script from "./SaleOfProducts.vue?vue&type=script&lang=ts"
export * from "./SaleOfProducts.vue?vue&type=script&lang=ts"
import style0 from "./SaleOfProducts.scss?vue&type=style&index=0&id=454983bd&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454983bd",
  null
  
)

export default component.exports